// Test IDs for password strength + two-factor authentication (MFA) UI.
// Keys camelCase, values kebab-case `<feature>-<element>`.

export const LOGIN_MFA = {
  section: 'login-mfa-challenge-section',
  codeInput: 'login-mfa-code-input',
  submitButton: 'login-mfa-submit-button',
  errorText: 'login-mfa-error-text',
  backLink: 'login-mfa-back-link',
  hint: 'login-mfa-hint-text',
};

export const MFA_CARD = {
  root: 'mfa-setup-card',
  statusEnabledBadge: 'mfa-status-enabled-badge',
  statusDisabledBadge: 'mfa-status-disabled-badge',
  backupCodesRemaining: 'mfa-backup-codes-remaining',
  startSetupButton: 'mfa-start-setup-button',
  qrImage: 'mfa-qr-image',
  secretText: 'mfa-secret-text',
  verifyCodeInput: 'mfa-verify-code-input',
  verifyCodeSubmit: 'mfa-verify-code-submit',
  cancelSetupButton: 'mfa-cancel-setup-button',
  setupErrorText: 'mfa-setup-error-text',
  backupCodesList: 'mfa-backup-codes-list',
  backupCodesDownload: 'mfa-backup-codes-download-button',
  backupCodesAckCheckbox: 'mfa-backup-codes-ack-checkbox',
  backupCodesDoneButton: 'mfa-backup-codes-done-button',
  regenerateButton: 'mfa-regenerate-backup-codes-button',
  disableButton: 'mfa-disable-button',
  disableDialog: 'mfa-disable-dialog',
  disablePasswordInput: 'mfa-disable-password-input',
  disableCodeInput: 'mfa-disable-code-input',
  disableConfirmButton: 'mfa-disable-confirm-button',
  disableErrorText: 'mfa-disable-error-text',
  regenerateDialog: 'mfa-regenerate-dialog',
  regeneratePasswordInput: 'mfa-regenerate-password-input',
  regenerateConfirmButton: 'mfa-regenerate-confirm-button',
  regenerateErrorText: 'mfa-regenerate-error-text',
};

export const CLIENT_SECURITY_PAGE = {
  root: 'client-account-security-page',
  backLink: 'client-security-back-link',
  changePasswordForm: 'client-change-password-form',
  currentPasswordInput: 'client-change-password-current-input',
  newPasswordInput: 'client-change-password-new-input',
  submitButton: 'client-change-password-submit-button',
};
